import Typography from "../Typography/Typography"
import styles from './style.module.css'

interface statProp {
    title?: "Complete" | "Pending";
}

export const StatusCard: React.FC<statProp> = ({
    title,
}) => {
    return (
        <div className={`${title === "Complete" ? styles.statContainerGreen : styles.statContainerOrange}`}>
            <Typography
                className={`${title === "Complete" ? styles.statGreen : styles.statOrange}`}
            >
                {title}
            </Typography>
        </div>
    )
}